/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/*jslint white: true */
/*jslint node: true */
/*global $, jQuery, Swiper, ScrollMagic*/

$(document).ready(function () {


	$("input[type=file]").change(function (e) {
		$(this).next('.custom-file-label').text(e.target.files[0].name);
	})

	$("[data-fancybox]").fancybox({

		afterClose: function () {
			$(".navbar-distribute-desk-collapse").removeAttr("style");
		}
	});

	$('.marquee').marquee({
		duplicated: true,
//		pauseOnHover: true,
		duration: 10000,
		startVisible: true
	});

	// FORMS CONTACT & POSTULER
	$('.gform_wrapper').on('click', '#attachment', function () {
        $('input[name="input_8"]').trigger('click');
	});

	// FORMS CONTACT & POSTULER
	$('input[name="input_8"]').change(function (e) {
		var file = e.target.files[0];
		if (file) {
			$('#file-upload span').text(file.name);
			$('#file-upload').show();
	
			$('#file-upload-2 span').text(file.name);
			$('#file-upload-2').show();
		}
	});

	// PAGE POSTULER
	$('.emplois-type').on('click', function () {
        if ( $(this).hasClass('active') ) {
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }
    });

	// PAGE POSTULER
    $('.filter-pays').on('click', function () {
        $('.filter-pays').removeClass('active');
        $(this).addClass('active');
        $('.offres-emplois').hide();
        $('*[data-pays="' + $(this).data('pays') + '"]').show();
        if ( !$('.offres-emplois*[data-pays="' + $(this).data('pays') + '"]').length ) {
            $('p.offres-emplois').show();
        }
	});

	var filter_pays = $('.filter-pays.active').data('pays');
	if ( !$('.offres-emplois.active*[data-pays="' + filter_pays + '"]').length ) {
		$('p.offres-emplois').show();
	}

	// PAGE POSTULER DETAILS
	$('.action-postuler').on('click', function () {
        if ( $('#collapseForm').hasClass('active') ) {
            $('#collapseForm').removeClass('active');
        } else {
            $('#collapseForm').addClass('active');

			$('html, body').animate({
				scrollTop: $("#collapseForm").offset().top
			}, 1000);
        }
    });
	
	
	// FORM NAVBAR
	$('.form-navbar').on('click', '#submit-form-navbar', function () {
		if ( $('#form-societe').val() != "" && $('#form-email').val() != "" && $('#form-objet').val() != "" && $('#form-message').val() != "" && $('#form-check').is(':checked')) {
			$('#gform_wrapper_3').show();
			$('#input_3_1').val($('#form-selection option:selected').text());
			$('#input_3_2').val($('#form-societe').val());
			$('#input_3_3').val($('#form-email').val());
			$('#input_3_4').val($('#form-objet').val());
			$('#input_3_5').val($('#form-message').val());

			$('#gform_submit_button_3').trigger('click');

			$('.form-navbar').hide();

			return false;
		}
	});
});






if ('objectFit' in document.documentElement.style === false) {
	document.addEventListener('DOMContentLoaded', function () {
		document.querySelectorAll('img[data-object-fit]').forEach(function (image) {
			(image.runtimeStyle || image.style).background = "url(\"".concat(image.src, "\") no-repeat 50%/").concat(image.currentStyle ? image.currentStyle['object-fit'] : image.getAttribute('data-object-fit'));
			image.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='".concat(image.width, "' height='").concat(image.height, "'%3E%3C/svg%3E");
		});
	});
}









// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});